export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "Registration success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["회원 가입이 완료 되었습니다"])}
    }
  })
}
